'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dayjs = require('dayjs');

var _dayjs2 = _interopRequireDefault(_dayjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (date) {
  var isValid = (0, _dayjs2.default)(date).isValid();
  if (isValid) {
    return (0, _dayjs2.default)(date).format();
  } else if (date.indexOf('/Date(') !== -1) {
    // Day.js does not now how to deal with JG formatted UNIX time, so strip out extra parts of string and just serve up digits of UNIX timestamp to convert to ISO
    var prepareStr = Number(date.replace('/Date(', '').replace(')/', '').split('+')[0]);
    var formatUnix = (0, _dayjs2.default)(prepareStr).format();
    return formatUnix;
  }
};